import type { FaireProductEntity } from "../../entity_types/product";

export const p_z3em5g485b: FaireProductEntity = {
  token: "p_z3em5g485b",
  type: "product",
  name: "Arkansas Razorbacks Trifecta Necklace",
  brandToken: "b_tafk34eq47",
  brandName: "From The Heart",
  imageUrl: "https://cdn.faire.com/fastly/1d85bde3a5c45dcaf8f11b20658a1b3a8978dbb658e1a31d0059d32bff2effa0.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.25,
  description: "Triple your team spirit with our Trifecta college jewelry collection. Each piece in this collection features a team color jewel, a silver logo charm and a nameplate with engraved mascot. Classy style meets college pride when you wear our triple charm Trifecta Collection.  The necklace is an 18 inch double cable chain with a two inch extender so you can customize your length. All items are made from zinc alloy and are sealed with a anti-tarnish coating.  Each piece is designed and assembled  by working moms and grandmothers at our production office just outside Tulsa, Oklahoma. Some components are Made in China then assembled proudly in the USA.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:33.308Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
